import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { CategoryService } from '../../../../_services/admin/category.service';
import { ProductsService } from './../../../../_services/admin/products.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {

  AddProductForm: FormGroup;
  isAddProductFormSubmitted = false;
  categoryList: any[] = [];
  checked = false;
  fileToUpload: File = null;

  constructor(private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    private myTitle: Title,
    private productService: ProductsService,
    private router: Router,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Add New Product | ' + environment.commonTitle);
    this.getCategory();
    this.AddProductForm = this.formBuilder.group({
      'ddlProductCategory': [null, Validators.required],
      'productName': [null, [Validators.required]],
      'capacity': [null, [Validators.required]],
      'price': [null, [Validators.required]],
      'description': [null, [Validators.required]],
      'chkDisplayOnHome': [null]
    });
  }

  getCategory() {
    this.categoryService.getAllCategories().subscribe((result) => {
      if (result.data) {
        this.categoryList = result.data;
      }
    });
  }

  AddProduct() {
    if (this.AddProductForm.valid) {
      const objdata = {
        ProductCategoryID: parseInt(this.AddProductForm.value.ddlProductCategory),
        Name: this.AddProductForm.value.productName,
        Capacity: this.AddProductForm.value.capacity,
        Price: parseFloat(this.AddProductForm.value.price),
        Description: this.AddProductForm.value.description,
        productImgObj: this.fileToUpload,
        isDisplayOnHome: this.AddProductForm.value.chkDisplayOnHome,
      };
      this.productService.addproduct(objdata).subscribe(result => {
        if (result.data) {
          this.getCategory();
          // this.toastr.success('Product saved successfully.', 'Product!');
          this.openSnackBar('Product saved succcessfully.', 'Product!');
          this.router.navigate(['/secure/home/product']);
          this.AddProductForm.reset();
        }
      }, error => {
        console.log(error);
        this.openSnackBar(error.error, 'Failed to save Product');
      });
    }
  }

  reditectProductList() {
    this.router.navigate(['/secure/home/product/products']);
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

}
